import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'lib/store';
import { MedicareApiPlan } from 'types/api';
import { isSamePlan } from 'utils/selectedPlans';

export interface CartState {
  cartPlans: MedicareApiPlan[];
  savedPlans: MedicareApiPlan[];
}

export const initialState: CartState = {
  cartPlans: [],
  savedPlans: [],
};

const cartSlice = createSlice({
  initialState,
  name: 'cart',
  reducers: {
    // Cart Actions
    addToCart: (state, action: PayloadAction<MedicareApiPlan>) => {
      const existingPlan = state.cartPlans.find((plan) =>
        isSamePlan(plan, action.payload)
      );
      if (!existingPlan) {
        state.cartPlans.push(action.payload);
      }
    },
    removeFromCart: (state, action: PayloadAction<MedicareApiPlan>) => {
      state.cartPlans = state.cartPlans.filter(
        (plan) => !isSamePlan(plan, action.payload)
      );
    },
    clearCart: (state) => {
      state.cartPlans = [];
    },

    // Saved Plans Actions
    savePlan: (state, action: PayloadAction<MedicareApiPlan>) => {
      const existingPlan = state.savedPlans.find((plan) =>
        isSamePlan(plan, action.payload)
      );
      if (!existingPlan) {
        state.savedPlans.push(action.payload);
      }
    },
    unsavePlan: (state, action: PayloadAction<MedicareApiPlan>) => {
      state.savedPlans = state.savedPlans.filter(
        (plan) => !isSamePlan(plan, action.payload)
      );
    },
    toggleSavePlan: (state, action: PayloadAction<MedicareApiPlan>) => {
      const existingSavedPlan = state.savedPlans.find((plan) =>
        isSamePlan(plan, action.payload)
      );

      if (existingSavedPlan) {
        // Remove from saved
        state.savedPlans = state.savedPlans.filter(
          (plan) => !isSamePlan(plan, action.payload)
        );
      } else {
        // Add to saved
        state.savedPlans.push(action.payload);
      }
    },
  },
});

const { actions, reducer } = cartSlice;

export const {
  addToCart,
  removeFromCart,
  clearCart,
  savePlan,
  unsavePlan,
  toggleSavePlan,
} = actions;

export const selectCartPlans = (state: RootState) => state.cart.cartPlans;
export const selectSavedPlans = (state: RootState) => state.cart.savedPlans;

export default reducer;
